// Lightweight heuristic intent detection for study assistant
// Export: detectIntent(text) -> { intent, confidence, modifiers }

const QUIZ_KEYWORDS = [
  "quiz",
  "mcq",
  "multiple choice",
  "practice test",
  "test me on",
  "generate a quiz",
  "make a quiz",
  "create a quiz",
  "question bank",
  "assessment",
];
const FLASHCARD_KEYWORDS = [
  "flashcard",
  "flashcards",
  "anki",
  "terms and definitions",
  "term list",
];
const SUMMARIZE_KEYWORDS = ["summarize", "tl;dr", "key points", "summary"];
const EXPLAIN_KEYWORDS = [
  "explain",
  "teach me",
  "walk me through",
  "break down",
];
const STUDY_PLAN_KEYWORDS = ["study plan", "study schedule", "syllabus plan"];
const COMPARE_KEYWORDS = [
  "compare",
  "comparison",
  "differences between",
  "similarities",
  "contrast",
  "versus",
  "vs",
];

function includesAny(text, arr) {
  return arr.some((k) => text.includes(k));
}

function extractNumber(text) {
  const m = text.match(/(\d{1,3})\s*(questions|qs|items)?/i);
  if (m) return parseInt(m[1], 10);
  return undefined;
}

function extractDifficulty(text) {
  if (/(easy|beginner|basic)/i.test(text)) return "easy";
  if (/(medium|intermediate)/i.test(text)) return "medium";
  if (/(hard|advanced|difficult)/i.test(text)) return "hard";
  return undefined;
}

export function detectIntent(raw) {
  const text = (raw || "").toLowerCase();
  const modifiers = {
    numQuestions: extractNumber(text),
    difficulty: extractDifficulty(text),
  };

  // Check compare first - it takes priority over other intents
  if (includesAny(text, COMPARE_KEYWORDS)) {
    return { intent: "compare", confidence: 0.85, modifiers };
  }
  if (includesAny(text, QUIZ_KEYWORDS)) {
    return { intent: "create_quiz", confidence: 0.9, modifiers };
  }
  if (includesAny(text, FLASHCARD_KEYWORDS)) {
    return { intent: "make_flashcards", confidence: 0.9, modifiers };
  }
  if (includesAny(text, SUMMARIZE_KEYWORDS)) {
    return { intent: "summarize", confidence: 0.8, modifiers };
  }
  if (includesAny(text, EXPLAIN_KEYWORDS)) {
    return { intent: "explain", confidence: 0.7, modifiers };
  }
  if (includesAny(text, STUDY_PLAN_KEYWORDS)) {
    return { intent: "study_plan", confidence: 0.75, modifiers };
  }

  return { intent: "general", confidence: 0.4, modifiers };
}
